import { render } from "./PackageAnalytics.vue?vue&type=template&id=5a047e46&scoped=true"
import script from "./PackageAnalytics.vue?vue&type=script&lang=js"
export * from "./PackageAnalytics.vue?vue&type=script&lang=js"

import "./PackageAnalytics.vue?vue&type=style&index=0&id=5a047e46&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a047e46"

export default script